/**
 * Compact global file-status badge. Independent of access, C/R, action required, and order.
 */

import { normalizePmFileReviewStatus } from "./clientDrawingReviewGroups";

export const CANONICAL_FILE_STATUS = Object.freeze({
  OPEN: "open",
  UNDER_REVIEW: "under_review",
  CHANGES_REQUESTED: "changes_requested",
  APPROVED: "approved",
});

export const CANONICAL_FILE_STATUS_LABEL = Object.freeze({
  open: "Open",
  under_review: "Under review",
  changes_requested: "Changes requested",
  approved: "Approved",
});

export const CANONICAL_FILE_STATUS_TONE = Object.freeze({
  open: "bg-slate-100 text-slate-800 border-slate-200",
  under_review: "bg-sky-50 text-sky-900 border-sky-200",
  changes_requested: "bg-amber-50 text-amber-900 border-amber-200",
  approved: "bg-emerald-50 text-emerald-900 border-emerald-200",
  unknown: "bg-slate-50 text-slate-600 border-slate-200",
});

/**
 * @returns {{ key: string, label: string, tone: string, known: boolean }}
 */
export function getCanonicalFileStatusBadge(file) {
  const s = normalizePmFileReviewStatus(file?.reviewStatus || file?.workflowStatus);
  let key = CANONICAL_FILE_STATUS.OPEN;
  let known = true;

  if (!s) {
    known = false;
    key = CANONICAL_FILE_STATUS.OPEN;
  } else if (s === "approved" || s === "approved_as_noted") {
    key = CANONICAL_FILE_STATUS.APPROVED;
  } else if (
    s === "changes_requested" ||
    s === "revisions_required" ||
    s === "returned" ||
    s === "rejected" ||
    s === "changes_required"
  ) {
    key = CANONICAL_FILE_STATUS.CHANGES_REQUESTED;
  } else if (
    s === "under_review" ||
    s === "in_review" ||
    s === "pending_client_review" ||
    s === "submitted" ||
    s === "resubmitted" ||
    s === "changes_submitted"
  ) {
    key = CANONICAL_FILE_STATUS.UNDER_REVIEW;
  } else if (
    s === "open" ||
    s === "draft" ||
    s === "for_information" ||
    s === "for_information_only" ||
    s === "info_only" ||
    s === "in_progress" ||
    s === "no_action" ||
    s === "closed" ||
    s === "cancelled" ||
    s === "canceled" ||
    s === "on_hold"
  ) {
    key = CANONICAL_FILE_STATUS.OPEN;
  } else {
    known = false;
    key = CANONICAL_FILE_STATUS.OPEN;
  }

  return {
    key,
    label: known ? CANONICAL_FILE_STATUS_LABEL[key] : "Open",
    tone: known ? CANONICAL_FILE_STATUS_TONE[key] : CANONICAL_FILE_STATUS_TONE.unknown,
    known,
  };
}
